<template>
  <div class="submit-wrapper">
    <div class="submit-block">
      <h5>Ready to submit?</h5>
      <md-button :disabled="is_closed || countErrors>0" @click="$emit('submit')" class="md-raised md-accent icon-right fb-submit-btn">{{ this.$route.name == "field_go_form" ? 'Go!' : 'Submit!' }} <md-icon>send</md-icon></md-button>
      <span v-if="countErrors" class="md-error"><span class="underline">{{countErrors}}</span> {{ 'section' | pluralize(countErrors)}} {{ 'need' | reverse_pluralize(countErrors)}} to be completed.</span>
    </div>
  </div>
</template>

<script>
import FbElementMixin from "./FbElementMixin";

export default {
  name: "FbSubmit",
  props: ["element", "mode", "validate", "showSubmit"],
  mixins: [FbElementMixin],
  computed: {
    valid() {
      return true;
    },
    countErrors() {
      return this.validationFails.filter((validation)=>{
        return !validation;
      }).length;
    }
  },
  data() {
    return {
      is_closed: window.drupalSettings.node.is_closed || false,
    };
  },
  created() {
    this.$emit("validation", this.valid);
  }
};
</script>

<style lang="scss" scoped>
.md-button.md-theme-default.md-accent.md-accent.icon-right[disabled] .md-icon {
  color:rgba(0, 0, 0, 0.26);
}
.underliune {
  text-decoration: underline;
}
.submit-wrapper {
  display: flex;
  flex: 1;
  align-items: center;
  justify-content: center;
  .submit-block {
    flex: 1;
    h5 {
      font-size: 18px;
      @media all and (min-width: $breakpoint-medium) {
        font-size: 20px;
      }
    }
  }
}
.fb-submit-btn {
  margin-top: 32px;
}
.md-button {
  font-size: 16px;
  height: 36px;
  @media all and (min-width: $breakpoint-medium) {
    font-size: 20px;
    height: 40px;
  }
}
</style>
